<template>
  <div class="layout-inner pg_content_container career_prospects">
    <navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">

        <template v-if="programGuide && programGuide.title">
          <program-guide-title :program-guide="programGuide"></program-guide-title>
        </template>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="row pg_sec career_prospect_v2">
            <div class="col-12 hd mt-4">
              <h2 aria-label="Spotlight Alumni">Spotlight Alumni</h2>
            </div>
            <div class="col-12 sec_content" style="padding-left: 5px; margin-right: 5px;">
              <template v-if="spotlightPersons.length > 0">
                <div class="row result_row" v-for="(person, index) in spotlightPersons">
                  <div class="col-3 thumbnail_container" style="margin-right: 10px;">
                    <div class="thumbnail_container_inner">
                      <img class="thumb_img"
                        v-if="person.thumbnailURI"
                        :src="person.thumbnailURI"
                        tabindex="0"
                        onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/program-default.svg';">
                      <div v-else class="default_thumb">
                        <span class="ic ic-degreeProgram"></span>
                      </div>
                    </div>
                  </div>
                  <div class="col-9 entity_details">
                    <div class="row">
                      <div class="col-12 entity_title">
                        <span class="title_txt ace_sec_txt" :id="'title_' + index" :aria-label="person.title">{{person.title}}{{getClassOf(person)}}</span>
                      </div>
                      <div class="col-12" style="padding-right: 0;">
                        <div class="row">
                          <div class="col-12 description ace_sec_txt" :id="'biography_' + index" v-if="person.biography">
                            <span class="desc_txt" v-html="person.biography"></span>
                          </div>
                          <div class="col-12 no_description empty_pattern ace_sec_txt" v-else>
                            Biography not added
                          </div>
                          <template v-if="person.biography && person.biography.length > 100">
                            <div class="program_desc col-12">
                              <b-link v-b-modal="'progDesc_' + person.uuid" style="color: #0645AD; float: right; text-align: right; padding-top: 8px;">more</b-link>

                              <b-modal :id="'progDesc_' + person.uuid" :title="person.title" hide-footer>
                                <div v-if="person.biography" v-html="person.biography"></div>
                              </b-modal>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row pg_sec sec_career mt-4">
                  <div class="col-12 career_chart_container" aria-label="Career Options" style="margin-bottom: 0px;" v-if="topCareers.length > 0">
                    <div class="row">
                      <div class="col-12">
                        <div class="hd" style="float: left; width: 230px;">
                          <h2 aria-label="Top Alumni Careers">Top Alumni Careers</h2>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 ace_sec">
                        
                          <div class="bar_chart_container bar_label_inside" role="tablist">
                            <template v-for="(career, index) in topCareers">
                              <div class="row bar_row ace_sec">
                                <div class="col-12 accordion acrdn_top_careers">
                                  <b-card no-body>
                                    <b-card-header header-tag="header" class="row_hd" role="tab">
                                      <b-button block v-b-toggle="'acrdnTopCareer_' + index" variant="info">
                                        <span class="btn_txt" @click.stop="navigateToCareer(career)">
                                          <span v-if="career.careerThumbnail">
                                            <img v-bind:src="career.careerThumbnail" style="height: 40px; width: 40px;">
                                          </span>
                                          <span class="ml-3">{{career.careerTitle}}</span>
                                        </span>
                                        <span class="ic ic8-circle-up"></span>
                                        <span class="ic ic8-circle-down"></span>
                                      </b-button>
                                    </b-card-header>
                                    <b-collapse :visible="index === 0" :id="'acrdnTopCareer_' + index" accordion="careers-accordion" role="tabpanel">
                                      <b-card-body class="row jobs_sec">
                                        <div class="bar_label"></div>

                                        <div class="card sec_bx">
                                          <div class="card-body">
                                            <div class="row sec_row income_sec">

                                              <div class="col-3 ic_container">
                                                <span class="ic ic9-salary"></span>
                                              </div>
                                              <div class="col-6 val">
                                                $<span v-html="addCommaInNumber(career.medianIncome)"></span>
                                              </div>
                                              <div class="col-3 label">
                                                Median Income
                                              </div>

                                            </div>
                                          </div>
                                        </div>

                                        <div class="card sec_bx">
                                          <div class="card-body">
                                            <div class="row sec_row growth">

                                              <div class="col-4 gph_chart">
                                                <div class="row lg_row">
                                                  <div class="col-6 lg">
                                                    <span class="lg_txt">0%</span>
                                                  </div>
                                                  <div class="col-6 lg">
                                                    <span class="lg_txt">15%</span>
                                                  </div>
                                                </div>
                                                <div class="row gauge_sec">
                                                  <div class="col-12">
                                                    <doughnut-chart :chart-data="growthPieData"  :id="'gauge-' + index" :options="growthPieOptions" @afterComplete="callDrawNeedle('gauge-' + index, career.growth)"></doughnut-chart>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-5 val">
                                                <span class="val_1_txt" v-html="(Math.round((career.growth) * 100) / 100).toFixed(1)"></span><span>%</span>
                                              </div>
                                              <div class="col-3 label">
                                                Estimated Job Growth {{career.timeframe}}
                                              </div>

                                            </div>
                                          </div>
                                        </div>

                                        <div class="card sec_bx">
                                          <div class="card-body">
                                            <div class="row sec_row">

                                              <div class="col-3 ic_container">
                                                <span class="ic ic9-job2"></span>
                                              </div>
                                              <div class="col-6 val">
                                                <span v-html="formatNumericVal(career.openings)"></span>
                                              </div>
                                              <div class="col-3 label">
                                                <div>
                                                  Job Postings 2020 - 2030
                                                </div>
                                              </div>

                                            </div>
                                          </div>
                                        </div>

                                        <div class="employers mb-4" v-if="career.employers && career.employers.length>0">
                                          <div class="bar_content">
                                            <div class="row">
                                              <div class="col-12" style="padding: 15px 5px;">
                                                <span>Companies that are hiring Alumni</span>
                                              </div>
                                              <div class="col-12">
                                                <div class="row bar_container mb-2" v-for="employer in career.employers" style="margin-left: -10px !important; margin-right: 32px !important;">
                                                  <div class="mt-2 ml-4 w-100">
                                                    <span class="float-left">{{employer.companyTitle}}</span>
                                                    <span class="float-right mr-4">{{employer.totalCount}} hired</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </div>
                            </template>
                          </div>

                      </div>
                    </div>
                  </div>

                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topCompanies.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2">
                        <div style="float: left; width: 300px;">
                          <h2 aria-label="Companies Hiring Alumni">Companies Hiring Alumni</h2>
                        </div>
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="companies bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topCompanies.length === 0)}">
                                <template v-if="topCompanies.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topCompanies">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.companyTitle}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} hired</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topIndustries.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2">
                        <div style="float: left; width: 325px;">
                          <h2 aria-label="Popular Alumni Insdustries">Popular Alumni Insdustries</h2>
                        </div>
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="industries bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topIndustries.length === 0)}">
                                <template v-if="topIndustries.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topIndustries">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.industry}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} jobs</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 hd ace_sec" style="margin-bottom: 0px;" v-if="topJobTitles.length > 0">
                    <div class="row pg_sec career_chart_container">
                      <div class="col-11 mb-2">
                        <div style="float: left; width: 350px;">
                          <h2 aria-label="Companies Hiring Alumni">Popular Alumni Job Titles</h2>
                        </div>
                      </div>
                      <div class="col-12 ace_sec bar_chart_container">
                        <div class="jobtitles bar_row" style="margin-left: 10px !important; margin-right: 32px !important;">
                          <div class="bar_content">
                            <div class="row">
                              <div class="col-12" :class="{'text-center': (topJobTitles.length === 0)}">
                                <template v-if="topJobTitles.length > 0">
                                  <div class="row bar_container mb-2" v-for="item in topJobTitles">
                                    <div class="mt-2 ml-4 w-100">
                                      <span class="float-left">{{item.jobTitle}}</span>
                                      <span class="float-right mr-4">{{item.totalCount}} jobs</span>
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <span>Data not available</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </template>
              <template v-else>
                <b-jumbotron>
                  <h4 class="text-center ace_sec_txt">Spotlight Alumni data is not available.</h4>
                </b-jumbotron>
              </template>
            </div>
          </div>
        </div>

        <program-footer-navbar :pageTitle="'Spotlight Alumni'" :returnTo="returnToPage" :params="{cipCode: cipCode, programGuideCode: programGuideCode, type: type}"></program-footer-navbar>

      </div>
    </div>
  </div>
</template>


<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import Navbar from '../../misc/components/./Navbar'
  import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
  import DoughnutChart from './DoughnutChart'
  import ProgramGuideTitle from './ProgramGuideTitle'

  export default {
    name: 'program-guide-spotlight-alumni',
    props: ['cipCode', 'programGuideCode', 'type', 'returnTo'],
    components: {
      Navbar,
      ProgramFooterNavbar,
      DoughnutChart,
      ProgramGuideTitle
    },
    data: () => {
      return {
        topCareers: [],
        topCompanies: [],
        topIndustries: [],
        topJobTitles: [],
        programGuide: {},
        DEFAULT_TYPE: 'MAJOR',
        DEFAULT_RETURN_TO: 'exploreIntro',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        growthPieOptions: {
          rotation: 1 * Math.PI,
          circumference: 1 * Math.PI,
          tooltips: {
            enabled: false
          }
        }
      }
    },
    async created () {
      if (!this.alumniData || !this.alumniData.spotlightPerson) {
        await this.loadProgramAlumniData(this.programGuideCode)
      }
      this.populateTopCareers()
      this.populateTopCompanies()
      this.populateTopIndustries()
      this.populateTopJobTitles()
    },
    mounted () {
      this.loadSpotlightAlumniData()
    },
    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadProgramAlumniData',
        'loadTopAlumniCareers',
        'loadCareerByCode',
        'loadTopEmployersForAlumniCareer',
        'loadTopAlumniCompanies',
        'loadTopAlumniIndustries',
        'loadTopAlumniJobTitles'
      ]),
      async populateTopCareers () {
        this.topCareers = []
        let data = await this.loadTopAlumniCareers(this.programGuideCode)
        let careers = data.content
        for (let i = 0; i < careers.length; i++) {
          let ac = careers[i]
          let code = ac.careerPragyaSoc
          let career = await this.loadCareerByCode(code)
          if (career) {
            ac.medianIncome = career.medianEarning
            ac.minIncome = career.annualEarning10thPercentile
            ac.maxIncome = career.annualEarning90thPercentile
            ac.growth = career.growth
            ac.timeframe = career.timeframe
            ac.openings = career.openings
          }
          let employers = await this.loadTopEmployersForAlumniCareer({programCode: this.programGuideCode, careerSoc: ac.careerSoc})
          ac.employers = _.orderBy(employers, ['totalCount'], ['desc'])
          this.topCareers.push(ac)
        }
      },
      async populateTopCompanies () {
        let data = await this.loadTopAlumniCompanies(this.programGuideCode)
        this.topCompanies = data.content
      },
      async populateTopIndustries () {
        let data = await this.loadTopAlumniIndustries(this.programGuideCode)
        this.topIndustries = data.content
      },
      async populateTopJobTitles () {
        let data = await this.loadTopAlumniJobTitles(this.programGuideCode)
        this.topJobTitles = data.content
      },
      async loadSpotlightAlumniData () {
        let cipCode = this.cipCode
        let programGuideCode = this.programGuideCode
        let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
        if (!cipCode || !programGuideCode) {
          return this.$router.push({ name: returnTo })
        }
        this.programGuide = await this.loadProgramGuide({
          cipCode: cipCode,
          programGuideCode: programGuideCode,
          type: this.programGuideType,
          loadDataFromServer: true
        })
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to program results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      updateTitleHeight (index) {
        let titleContainerHeight = $('#title_' + index).height()
        if (titleContainerHeight > 30) {
          $('#biography_' + index).addClass('srt_desc')
        }
      },
      getClassOf (person) {
        if (person.educationInfoList && person.educationInfoList.length > 0) {
          return ' - Class of ' + person.educationInfoList[0].classOf
        }
        return ''
      },
      navigateToCareer (career) {
        let routerParams = {
          code: career.careerPragyaSoc,
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          returnTo: 'programGuideSpotlightAlumni'
        }
        return this.$router.push({ name: 'careerDetail', params: routerParams, query: {returnTo: 'programGuideSpotlightAlumni'} })
      },
      addCommaInNumber (numValue) {
        if (numValue && numValue.length > 0) {
          let numericValue = Math.floor(numValue)
          return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return numValue
      },
      formatNumericVal (numValue) {
        let numericValue = Math.floor(numValue)
        return numericValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      callDrawNeedle (el, value) {
        if (!document || !document.getElementById(el)) return
        let canvas = document.getElementById(el).childNodes[1]
        if (canvas) {
          if (value && value < -10) {
            this.drawNeedle(canvas, 35, -170 * Math.PI / 180)
          } else if (value && value >= -10 && value < -5) {
            this.drawNeedle(canvas, 35, -150 * Math.PI / 180)
          } if (value && value >= -5 && value < 0) {
            this.drawNeedle(canvas, 35, -130 * Math.PI / 180)
          } else if (value && value >= 0 && value < 5) {
            if (value === '0.0') {
              this.drawNeedle(canvas, 35, -125 * Math.PI / 180)
            } else {
              this.drawNeedle(canvas, 35, -110 * Math.PI / 180)
            }
          } else if (value && value >= 5 && value < 10) {
            this.drawNeedle(canvas, 35, -90 * Math.PI / 180)
          } else if (value && value >= 10 && value < 15) {
            this.drawNeedle(canvas, 35, -70 * Math.PI / 180)
          } else if (value && value >= 15 && value < 20) {
            this.drawNeedle(canvas, 35, -50 * Math.PI / 180)
          } else if (value && value >= 20 && value < 25) {
            this.drawNeedle(canvas, 35, -30 * Math.PI / 180)
          } else if (value && value >= 25) {
            this.drawNeedle(canvas, 35, -10 * Math.PI / 180)
          }
        }
      },
      drawNeedle (canvas, radius, radianAngle) {
        var ctx = canvas.getContext('2d')
        var cw = canvas.offsetWidth
        var ch = canvas.offsetHeight
        var cx = cw / 2
        var cy = ch - (ch / 4)

        ctx.translate(cx, cy)
        ctx.rotate(radianAngle)
        ctx.beginPath()
        ctx.moveTo(0, -5)
        ctx.lineTo(radius, 0)
        ctx.lineTo(0, 5)
        ctx.fillStyle = 'rgba(100, 100, 100, 1)'
        ctx.fill()
        ctx.rotate(-radianAngle)
        ctx.translate(-cx, -cy)
        ctx.beginPath()
        ctx.arc(cx, cy, 7, 0, Math.PI * 2)
        ctx.fill()
      },
      expandCollapseBio (index) {
        let elemId = '#biography_' + index
        $(elemId).toggleClass('description')
        let el = '#more-less-' + index
        if ($(elemId).hasClass('description')) {
          $(el).text('more')
        } else {
          $(el).text('less')
        }
      }
    },
    computed: {
      ...mapState({
        'alumniData': state => state.programguide.programAlumniData,
        'packages': state => state.institution.packages
      }),
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      },
      spotlightPersons () {
        if (this.alumniData && this.alumniData.spotlightPerson) {
          if (this.alumniData.spotlightPerson.length > 3) {
            return _.slice(this.alumniData.spotlightPerson, 0, 3)
          }
          return this.alumniData.spotlightPerson
        }
        return []
      },
      growthPieData () {
        let data = {
          datasets: [
            {
              labels: 'Growth',
              backgroundColor: ['#f5b518', '#9fc958', '#0a7714'],
              data: [15, 15, 15]
            }
          ]
        }
        return data
      },
      returnToPage () {
        return this.returnTo || 'programGuideMenu'
      }
    }
  }
</script>

<style scoped>
  .result_row {
    margin-bottom: 5px;
  }
  .description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-box-pack: center;
    color: rgb(120 120 120);
  }
  .entity_title {
    font-weight: 600;
    width: 100%;
    padding: 0;
    padding-left: 10px;
    color: #323232;
    text-align: left;
    margin-bottom: 8px;
  }
  .entity_title .title_txt {
    font-size: 15px;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideSpotlightAlumni.vue